<template>
  <router-view />
</template>

<script>
export default {
  name: "plan",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
